
import classNames from 'classnames';
import './styles.scss';
const Button = ({ uiType, width, children, ...props}) => {
    return (
        <button {...props} className={classNames({
            'd-button': true,
            [`d-button--ui-type-${uiType}`]: true,
            [`d-button--full-width`]: width === 'full'
        })}>{children}</button>
    );
}

export default Button;